<template>
  <div class="ma-4">
   <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
   <ClientNav/>
   <v-row dense>
    <v-col cols="12" lg="3" xl="2">
      <ClientSide />
    </v-col>
    <v-col cols="12" lg="9" xl="10">
      <v-card class="pa-2" outlined tile height="100%">
    <v-data-table
      :headers="headers"
      :items="logs"
      sort-by="Date"
      sort-desc
      :loading="isLoading"
      loading-text="Loading Communication Logs"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Communication Logs</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="search"
            label="search"
            class="desktop"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="100%">
            <template v-slot:activator="{ on }">
              <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()"
                >
                <v-icon left>add</v-icon>
                Add Log</v-btn
              >
            </template>
          </v-dialog>
        </v-toolbar>
        <v-text-field
          v-model="search"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          label="search"
          class="mobile ml-5 mr-5 mb-3 mt-3"
        ></v-text-field>
      </template>

     <template v-slot:item.actions="{ item }">
      <span v-if="item.downloadables?.length > 0">
            <v-icon small class="mr-2" @click="downloadDocument(item)">
                mdi-download
            </v-icon>
        </span>

        <v-icon small class="mr-2" @click="downloadPDF(item)">
          mdi-file-pdf-box
        </v-icon>

        <v-icon small class="mr-2" @click="viewCommunication(item)">
          mdi-eye
        </v-icon>
        
        <v-icon small @click="deleteCommunication(item)">
          mdi-delete
        </v-icon>
        
      </template>
      <template v-slot:no-data>
        <v-btn color="#2b3990" class="white--text" @click="getCommunications()">Reset</v-btn>
      </template>
    </v-data-table>
      </v-card>
    </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
import axios from "axios";
import ClientNav from "@/components/ClientNav";
import ClientSide from "@/components/ClientSide";
import Foot from "@/components/Footer";

// import moment from 'moment'

const url = require("../client_config/config").url;

export default {
  components: {
    ClientNav,
    ClientSide,
    Foot,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "Date",
        },
        { text: "Time", value: "Time" },
        { text: "Note Type", value: "NoteType" },
        { text: "Notes", value: "Notes" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      dialog: false,
      editLog: false,
      newLog: false,
      msg: false,
      menu: false,
      signed: false,
      search: "",
      text: "",
      logs: [],
      isLoading: false,
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
  },

  created() {
    this.clientID = this.$route.params.clientID;
    this.getCommunications();
  },

  methods: {
    getCommunications: function () {
      this.isLoading = true;
      axios
        .get(`${url}/communications/${this.clientID}`)
        .then((res) => {
          const allowedExtensions = [
          'pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'JPG', 'PNG', 'JPEG'
          ];
          this.logs = res.data.communication.map((item) => {
            if (item.documents && item.documents.length > 0) {
              item.downloadables = item.documents.filter((doc) => {
                const ext = doc.AWSLink.split(".").pop().toLowerCase();
                return allowedExtensions.includes(ext);
              });
            }
            return item;
          });
        })
        .finally(() => (this.isLoading = false));
    },

    viewCommunication(item) {
      this.$router.push({
        name: "CommunicationForm",
        params: {
          clientID: this.clientID,
          action: "view",
          communicationID: item._id,
        },
      });
    },

    showAdd() {
      this.$router.push({
        name: "CommunicationForm",
        params: { clientID: this.clientID, action: "add" },
      });
    },

    deleteCommunication(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this communication log?") &&
        this.communicationDelete(id);
    },

    communicationDelete(id) {
      axios.delete(`${url}/communications/${id}`).then((response) => {
        this.getCommunications();
        if (response.status == 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The communication log has been deleted successfully.";
      });
    },

    downloadDocument(item) {
      if (item.documents && item.documents.length > 0) {
        for (let i = 0; i < item.documents.length; i++) {
          let document = item.documents[i];
          let documentName = document.Name || "";
          let documentLink = document.AWSLink || "";
          let FileSaver = require("file-saver");
          FileSaver.saveAs(documentLink, documentName);
        }
      }
    },

    downloadPDF(item) {
      const data = {
        clientID: this.clientID,
        Date: item.Date,
        Time: item.Time,
        Contacted: item.Contacted,
        Specify: item.Specify,
        NoteType: item.NoteType,
        Notes: item.Notes,
        CommType: item.CommType,
        CreatedBy: item.CreatedBy,
        documents: Array.isArray(item.documents)
          ? item.documents
              .map((doc) => doc && doc.AWSLink)
              .filter((link) => typeof link === "string" && !!link)
          : [],
        CommunicationLogVideo: item.CommunicationLogVideo
          ? item.CommunicationLogVideo.split(",")
          : [],
        CommunicationAudio: item.CommunicationAudio,
      };

      axios
        .post(`${url}/communications/generate-pdf`, data, {
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `communication-log-${item.Date}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          console.error("Error generating PDF:", error);
          this.msg = true;
          this.text = "Error generating PDF. Please try again.";
        });
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
</style>
